import { NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ASSET_CONSTANTS } from '../../../shared/constants/asset-constants';

@Component({
  selector: 'app-mb-logo',
  imports: [NgOptimizedImage],
  templateUrl: './mb-logo.component.html',
})
export class MbLogoComponent {
  @Input() size?: 'small';

  getLogoSize() {
    switch (this.size) {
      case 'small':
        return 'w-7';
      default:
        return 'w-42';
    }
  }

  getLogoSrc(): string {
    return this.size === 'small' ? ASSET_CONSTANTS.LOGO_MIN : ASSET_CONSTANTS.LOGO;
  }

  protected readonly ASSET_CONSTANTS = ASSET_CONSTANTS;
}
